import {getCookie,delCookie} from "@/utils/cookie";
import {getCmsUser} from "@/api/Patent";


export default {
    namespaced: true,
    state: () => {
        return {
            userinfo: {
                token: '',
                username: ''
            }
        }
    },
    mutations: {
        updateName(state, payload) {
            state.userinfo.username = payload;
        },
        updateToken(state, payload) {
            state.userinfo.token = payload;
        }


    },
    actions:{
        updateNameAsync({commit},payload){
            setTimeout(() => {
                commit('updateName',payload)
            }, 2000);
        },
        updateToeknAsync({commit},payload){
            commit('updateToken',payload)
        },
        // 请求后台，加载分类数据
        async getTokenFromCookie({commit}){
            try {
                // 发送请求，请求所有分类类别
                const token = getCookie('token')
                if(token){
                    const res=await getCmsUser()
                    // console.log('获取到的用户数据：',res)
                    commit('updateToken',token)
                    commit('updateName',res.cmsUser.name)
                }
            } catch (error) {
                // token 已失效（过期/被吊销），清理本地残留
                delCookie('token')
                commit('updateToken','')
                console.log(error);
            }
        },
        async logout({commit}){
            delCookie('token')
            commit('updateToken','')
        },
    },
    getters:{
        
    }
}